import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@fortem-monorepo/react-ui'

type Props = React.PropsWithChildren<{ title: string; description: string; pending: boolean; onClose: () => void }>

/** Presentation and dismissal guards shared by the two independent workflows. */
export const StrategyDialogFrame = ({ title, description, pending, onClose, children }: Props) => (
  <Dialog
    open
    onOpenChange={(open) => {
      if (!open && !pending) {
        onClose()
      }
    }}
  >
    <DialogContent
      className="max-h-[90svh] overflow-y-auto sm:max-w-2xl"
      onEscapeKeyDown={(event) => {
        if (pending) {
          event.preventDefault()
        }
      }}
      onInteractOutside={(event) => {
        if (pending) {
          event.preventDefault()
        }
      }}
    >
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
)
